<template>
	<div>
		<div class="bg-primary">
			<v-container class="py-0">
				<v-row>
					<v-col class="py-0">
						<v-tabs v-model="tab" background-color="theme_primary" grow dark slider-color="#FFED00">
							<v-tab class="font-weight-regular">
								Beneficios
							</v-tab>
							<v-tab class="font-weight-regular">
								Serviços
							</v-tab>
							<v-tab class="font-weight-regular">
								Cadastro
							</v-tab>
						</v-tabs>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<div class="bg-main">
			<v-container>
				<v-row>
					<v-col>
						<v-tabs-items v-model="tab" >
							<v-tab-item>
								<Beneficio></Beneficio>
							</v-tab-item>
							<v-tab-item>
								<Servico></Servico>
							</v-tab-item>
							<v-tab-item>
								<Cadastro></Cadastro>
							</v-tab-item>
						</v-tabs-items>
					</v-col>
				</v-row>
			</v-container>
		</div>
		<div class="bg-main">
			<v-container>
				<v-row>
					<v-col>
						<h3 class="text-32 font-weight-regular mb-6">Auxílio Emergencial</h3>
						<v-card><!-- thecontent -->
							<v-container>
								<v-row class="mb-4">
									<v-col cols="12" sm="4">
										<iframe class="w-100"
												:src="beneficio.urlVideo">
										</iframe>
									</v-col>
									<v-col cols="12" sm="8">
										{{beneficio.texto}}
									</v-col>
								</v-row>
								<v-row align="center" justify="center">
									<v-col cols="12" sm="4">
										<h3 class="mb-6">Você deseja concorrer a este Benefício?</h3>
										<v-btn :href="beneficio.formulario" class="mb-4" block color="info">Concorrer</v-btn>
										<v-btn :to="{name: 'Home'}" block>Não obrigado</v-btn>
									</v-col>
								</v-row>
							</v-container>
						</v-card>
					</v-col>
				</v-row>

			</v-container>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		name: "BeneficioDetail",
		async mounted() {
			let response = await axios.get('/beneficio/1');
			this.beneficio = response.data;
		},
		data: () => ({
			beneficio: {}
		})
	}
</script>

<style scoped>

</style>
